import * as Yup from 'yup';
import { PUSH_AUDIENCE } from './types';

export const MAX_PUSH_TITLE_LENGTH = 50;
export const MAX_PUSH_MESSAGE_LENGTH = 150;

export const customPushValidationSchema = Yup.object().shape({
	title: Yup.string()
		.trim()
		.required('Title is required')
		.max(MAX_PUSH_TITLE_LENGTH, `Title must be at most ${MAX_PUSH_TITLE_LENGTH} characters`),
	body: Yup.string()
		.trim()
		.required('Message is required')
		.max(MAX_PUSH_MESSAGE_LENGTH, `Message must be at most ${MAX_PUSH_MESSAGE_LENGTH} characters`),
	audience: Yup.string().required(),
	organizationId: Yup.number()
		.nullable()
		.when('audience', {
			is: PUSH_AUDIENCE.ORGANIZATION,
			then: Yup.number().nullable().required('Organization is required').typeError('Organization is required'),
		}),
});
